import React from 'react';

export const Header = ({ children }) => (
  <h3 className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
    {children}
  </h3>
);
